import React, { useCallback } from 'react';
import { Header, Link, Button, CarouselImage, NoWrap, CarouselText } from 'components';
import { config, Scroller, useWindowSize } from 'helpers';
import css from './hero.scss';

export function Hero(props) {

  const { height } = useWindowSize();

  const scrollToNext = useCallback(() => {
    new Scroller().to(height*0.6, {duration: 1500 });
  }, [ height ]);

  return (
    <div className={css.hero}>
      <CarouselImage className={css.background}>
        { props.images.slice(props.current, props.current + 1) }
      </CarouselImage>

      <div className={[css.container, props.scrolledPast && css.scrolledPast].join(' ')}>
        <Header.Compensate ref={props.refHeaderBreakpoint} />

        <CarouselText current={props.current} className={css.carousel}>
          { config.gw && <h2 id="carousel-0">Gain Clarity, Focus & <NoWrap>Direction in Life</NoWrap></h2> }
          { config.gw && <h2 id="carousel-1">Develop Your Personal <NoWrap>Roadmap to Success</NoWrap></h2> }
          { config.sw && <h2 id="carousel-2">Regain your passion, Purpose <NoWrap>and Prosperity</NoWrap></h2> }
          { config.sw && <h2 id="carousel-3">Discover what you really want out of life</h2> }
          <h2 id="carousel-4">Achieve Your Most Significant <NoWrap>Life Goals</NoWrap></h2>
          <h2 id="carousel-5">Create a Happier, more Authentic and <NoWrap>Fulfilling Lifestyle</NoWrap></h2>
        </CarouselText>

        <div className={css.textContainer}>
          <p>{ config.appName } provides you with a structured step-by-step process and a powerful set of tools that will educate, support, and guide you through a personal life-changing journey of self-discovery and self-realization.</p>
          <p>
            <Link to="/sign-up/?redirect=/settings/membership/" className={[css.buttonWrap, props.scrolledPast && css.scrolledPast].join(' ')}>
              <Button className={[css.button, props.status].join(' ')}>Start { config.trialPeriod }</Button>
              <span>Start { config.trialPeriod }</span>
            </Link>
          </p>
        </div>
      </div>
      <Button unfilled className={[css.scrollLink, props.scrolledPast && css.scrolledPast].join(' ')} onClick={scrollToNext}>Learn more</Button>
    </div>
  );
}
